import { useLanguage } from "@next-platform/client-common-core";
import { useCallback } from "react";

import useLocalizedLocation from "./useLocalizedLocation";
import { useLocalizedPathname } from "./useLocalizedPathname";

interface LocalizedUrlOptions {
  languageCode?: string;
  route?: string;
}

export function useLocalizedUrl() {
  const { currentLanguage } = useLanguage();
  const { pagePath } = useLocalizedLocation();
  const localizePathname = useLocalizedPathname();

  return useCallback(
    (options?: LocalizedUrlOptions) => {
      const origin = window.location.origin;
      const langCode = options?.languageCode || currentLanguage;
      const path = options?.route || pagePath;

      return `${origin}${localizePathname(path, langCode)}`;
    },
    [localizePathname, pagePath, currentLanguage],
  );
}
